import { render, staticRenderFns } from "./StatementDateFilter.vue?vue&type=template&id=b51c111a&scoped=true"
import script from "./StatementDateFilter.vue?vue&type=script&lang=js"
export * from "./StatementDateFilter.vue?vue&type=script&lang=js"
import style0 from "./StatementDateFilter.vue?vue&type=style&index=0&id=b51c111a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51c111a",
  null
  
)

export default component.exports